module.exports = __webpack_public_path__ + "static/media/manifest_attach_icon.84c3f6d9.svg";